import { request } from 'core/constants'
import { requestState } from 'utils/UtilityStore/actions'

export const fetch =
  (filter, order = null, orderDirection = null) =>
  (dispatch) => {
    dispatch(requestState(true, 'propertyOwners'))
    const orderBy = order && orderDirection ? order + ',' + orderDirection : ''

    request
      .get(
        `{company}/property-owner?page=${filter?.page || 1}&search=${
          filter?.search || ''
        }&orderBy=${orderBy}`,
      )
      .then((response) => {
        dispatch(requestState(false, 'propertyOwners'))
        dispatch({
          type: 'FETCH_PROPERTY_OWNERS',
          payload: response.data,
          listInfo: response.resultsInfo,
        })
      })
      .catch((error) => {})
  }
